import React, { useContext } from 'react';
import { AuthContext } from './AuthContext';
import './QrCode.css';

function QrCode() {
  const { tbsUser } = useContext(AuthContext);
  const qrData = tbsUser?.qr_code ?? tbsUser?.qRcode ?? tbsUser?.qrCode;

  return (
    <div className="qr-page">
      <h1>DROP & GO QR Code</h1>
      <p className="qr-subtitle">
        Scan this QR code at any participating Beer Store location when using Drop & Go to return your empties.
      </p>

      <div className="qr-card">
        {qrData ? (
          <>
            <img src={qrData} alt="Your QR Code" className="qr-image" />
            <p className="qr-name">{tbsUser.first_name} {tbsUser.last_name}</p>
          </>
        ) : (
          <p className="qr-unavailable">QR code not available for your account.</p>
        )}
      </div>
    </div>
  );
}

export default QrCode;
